import { useState } from 'react';

import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import './ProviderCustomList.scss';

const ListContent = props => (
  <Box className='ListContent'>
    <ul style={{ borderWidth: props.borderBottomList ? 1 : 0 }}>
      {(props.items || []).map((item, i) =>
        <li key={i}>
          <Typography variant='normalInter' color='text.primary' lineHeight='0.75rem' component='p'>
            {item}
          </Typography>
        </li>
      )}
    </ul>
  </Box>

);

const ProviderCustomList = props => {
  const [isTruncated, setIsTruncated] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const { items, title, listLength, borderBottomList } = props;
  const itemsInScope = items.filter((item, i) =>
    isTruncated
      ? i < listLength
      : true
  );

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <Box className='ProviderCustomList'>
      <Accordion
        defaultExpanded
        onChange={handleExpansion}
        className='ProviderCustomList__accordion'
      >
        {
          title
            ? <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant='paragraphSmall' color='text.light' component='p'>
                {title}
              </Typography>
            </AccordionSummary>
            : null
        }
        <AccordionDetails>
          <ListContent
            items={itemsInScope}
            itemCount={items.length}
            isTruncated={isTruncated}
            listLength={listLength}
            onExpand={() => setIsTruncated(false)}
            borderBottomList={borderBottomList}
          />
        </AccordionDetails>
      </Accordion>
      {
        !expanded && isTruncated && items.length > listLength
          ?
          <Box className='ListContent__button-box'>
            <Button
              className='p-0'
              onClick={() => setIsTruncated(false)}
            >
              <Typography variant='normalInter' color='text.blue' lineHeight='normal' sx={{ textDecoration: 'underline' }}>
                See More
              </Typography>
            </Button>
          </Box>
          : <></>
      }
    </Box>
  );
};

ProviderCustomList.defaultProps = {
  listLength: 2,
};

export default ProviderCustomList;
